<template>
  <m-card915 :image="content.thumbnail" :alt="content.title">

    <template #p-1>
      <m-a :href="{name:'SinglePost',params:{slug:content.slug}}">
        <m-h6 class="text-dark">{{ content.title }}</m-h6>
      </m-a>
      <p v-html="contentSlicer(content.abstraction)"></p>
    </template>

    <template #p-2>


      <div class="">
        <svg class="mx-1 d-inline-block" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" display="block"
             id="Calendar" data-v-33d9b80f="">
          <rect x="2" y="4" width="20" height="18" rx="4" data-v-33d9b80f=""></rect>
          <path
              d="M8 2v4" data-v-33d9b80f=""></path>
          <path d="M16 2v4" data-v-33d9b80f=""></path>
          <path d="M2 10h20" data-v-33d9b80f=""></path>
        </svg>
        <span>
        {{ dateConverter(content.created_at, '/') }}
      </span>
      </div>

      <div class="w-100 ">
        <m-a class="" :href="{name:'SinglePost',params:{slug:content.slug}}">
          <button class="border-0 text-dark text-left font-weight-bold btn-sm btn">
            <span class="pl-1" v-t="`post.card.more`"></span>
            <m-icon icon="arrow-left"/>
          </button>
        </m-a>
      </div>


    </template>

  </m-card915>
</template>

<script>
import mCard915 from '../../Cards/Card915.vue'
import mIcon from "../../Icons/Icon.vue";
import mA from "../../Tags/A.vue";
import mH6 from "../../Tags/H6.vue";
import {contentSlicer} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "PostCard915",
  methods: {dateConverter, contentSlicer},
  props: {
    content: {}
  },
  components: {mH6, mA, mIcon, mCard915},

}
</script>

<style scoped>

</style>